
import { supabase } from "@/integrations/supabase/client";

export const performDutchAccommodationSearch = async (query: string) => {
  try {
    console.log('Performing Dutch accommodation search for:', query);
    
    const searchTerm = query.toLowerCase().trim();
    
    // Detect Dutch vacation types
    const isDutchVacation = 
      searchTerm.includes('nederland') ||
      searchTerm.includes('holland') ||
      searchTerm.includes('camping') ||
      searchTerm.includes('vakantiepark') ||
      searchTerm.includes('landal') ||
      searchTerm.includes('roompot') ||
      searchTerm.includes('center parcs') ||
      searchTerm.includes('bungalow') ||
      searchTerm.includes('chalet') ||
      searchTerm.includes('huisje') ||
      searchTerm.includes('vakantiehuis') ||
      searchTerm.includes('recreatiepark') ||
      searchTerm.includes('bospark') ||
      searchTerm.includes('strandhuisje');

    if (!isDutchVacation) {
      return [];
    }

    console.log('Detected Dutch accommodation search');

    // Build specific search conditions for Dutch accommodations
    const conditions: string[] = [];
    
    // Country filter for Netherlands
    const countryCondition = `country.ilike.%nederland%,country.ilike.%holland%`;
    
    // Accommodation type conditions
    if (searchTerm.includes('camping')) {
      conditions.push(
        `name.ilike.%camping%`,
        `description.ilike.%camping%`,
        `typeAccommodatie.ilike.%camping%`,
        `specialCategories.ilike.%camping%`
      );
    }
    
    if (searchTerm.includes('vakantiepark') || searchTerm.includes('recreatiepark')) {
      conditions.push(
        `name.ilike.%vakantiepark%`,
        `name.ilike.%recreatiepark%`,
        `description.ilike.%vakantiepark%`,
        `description.ilike.%recreatiepark%`,
        `typeAccommodatie.ilike.%vakantiepark%`,
        `specialCategories.ilike.%vakantiepark%`
      );
    }
    
    if (searchTerm.includes('landal')) {
      conditions.push(
        `name.ilike.%landal%`,
        `description.ilike.%landal%`,
        `aanbieder.ilike.%landal%`
      );
    }
    
    if (searchTerm.includes('roompot')) {
      conditions.push(
        `name.ilike.%roompot%`,
        `description.ilike.%roompot%`,
        `aanbieder.ilike.%roompot%`
      );
    }
    
    if (searchTerm.includes('center parcs')) {
      conditions.push(
        `name.ilike.%center parcs%`,
        `name.ilike.%centerparcs%`,
        `description.ilike.%center parcs%`,
        `aanbieder.ilike.%center parcs%`
      );
    }
    
    if (searchTerm.includes('bungalow') || searchTerm.includes('chalet') || searchTerm.includes('huisje')) {
      conditions.push(
        `name.ilike.%bungalow%`,
        `name.ilike.%chalet%`,
        `name.ilike.%huisje%`,
        `name.ilike.%vakantiehuis%`,
        `description.ilike.%bungalow%`,
        `description.ilike.%chalet%`,
        `description.ilike.%huisje%`,
        `typeAccommodatie.ilike.%bungalow%`,
        `typeAccommodatie.ilike.%chalet%`
      );
    }

    // Combine country filter with accommodation conditions
    let finalConditions: string[] = [];
    
    if (conditions.length > 0) {
      // Specific accommodation type search in Netherlands
      finalConditions = [
        `(${countryCondition}) AND (${conditions.join(' OR ')})`
      ];
    } else {
      // General Netherlands search
      finalConditions = [countryCondition];
    }

    const { data, error } = await supabase
      .from('Complete feed')
      .select('*')
      .not('imageURL', 'is', null)
      .not('name', 'is', null)
      .or(finalConditions.join(','))
      .limit(100);

    if (error) throw error;

    console.log(`Dutch accommodation search found ${data?.length || 0} results for "${query}"`);

    const validatedData = (data || []).map((vacation: any) => ({
      ...vacation,
      name: vacation.name || "Onbekende vakantie",
      imageURL: vacation.imageURL || "/placeholder.svg"
    }));

    return validatedData;
  } catch (error: any) {
    console.error('Dutch accommodation search error:', error);
    throw error;
  }
};
